'use strict';

// v = 2.0

import dispatcher from '../dispatcher';
import loaderStore from './loader.store';


let html = document.documentElement;

const status = [
  'start',
  'start-complete',
  'end',
  'end-complete'
];

let loader;
let loaderStatus = status[1];
let progress = 0;




function _handleStart(e) {
  progress = 0;
  dispatcher.dispatch({
    type: 'load-animation',
    data: status[0]
  });

  html.classList.remove('la-' + status[1], 'la-' + status[2]);
  html.classList.add('la-' + status[0]);
  loaderStatus = status[0];
}
function _handleEnd() {
  dispatcher.dispatch({
    type: 'load-animation',
    data: status[2]
  });

  html.classList.remove('la-' + status[0], 'la-' + status[3]);
  html.classList.add('la-' + status[2]);

  loaderStatus = status[2];
}

function _startCompleteCallback() {
  html.classList.remove('la-' + status[2], 'la-' + status[3], 'la-' + status[0]);
  html.classList.add('la-' + status[1]);

  dispatcher.dispatch({
    type: 'load-animation',
    data: status[1]
  });

  loaderStatus = status[1];
}
function _endCompleteCallback() {
  html.classList.remove('la-' + status[0], 'la-' + status[1], 'la-' + status[2]);
  html.classList.add('la-' + status[3]);

  dispatcher.dispatch({
    type: 'load-animation',
    data: status[3]
  });

  loaderStatus = status[3];
}







function init() {
  loader = document.querySelector('.loader');

  if (!loader) return;

  loader.addEventListener('transitionend', (e) => {
    if (e.pseudoElement || e.target !== loader) return;

    const data = loaderStore.getData();

    if (loaderStatus === status[0]) _startCompleteCallback();
    if (loaderStatus === status[2]) _endCompleteCallback();

    if (progress >= 100 && data.loaded && loaderStatus === status[1]) _handleEnd();
  }, false);


  loaderStore.eventEmitter.subscribe((e) => {
    if (e.type === 'loading') _handleStart(e);
    if (e.type === 'loading-progress') progress = e.progress;
  });

  dispatcher.subscribe(e => {
    if (e.type === 'mutate' && loaderStatus === status[1]) _handleEnd();
  })

  setTimeout(() => _handleEnd(), 10);
}

export default {
  init: init
}
